import { defineAsyncComponent } from 'vue'

export default {
  enhance: ({ app }) => {    
      app.component("FeedbackForm", defineAsyncComponent(() => import("/workspaces/ft-docs/docs/.vuepress/components/FeedbackForm.vue")))
    
      app.component("PageContentBottom", defineAsyncComponent(() => import("/workspaces/ft-docs/docs/.vuepress/components/PageContentBottom.vue")))
    
      app.component("ProfileLink", defineAsyncComponent(() => import("/workspaces/ft-docs/docs/.vuepress/components/ProfileLink.vue")))
    
      app.component("ProfilePage", defineAsyncComponent(() => import("/workspaces/ft-docs/docs/.vuepress/components/ProfilePage.vue")))
    
      app.component("SpotlightDetails", defineAsyncComponent(() => import("/workspaces/ft-docs/docs/.vuepress/components/SpotlightDetails.vue")))
    
      app.component("SpotlightOverview", defineAsyncComponent(() => import("/workspaces/ft-docs/docs/.vuepress/components/SpotlightOverview.vue")))
    
      app.component("VimeoPlayer", defineAsyncComponent(() => import("/workspaces/ft-docs/docs/.vuepress/components/VimeoPlayer.vue")))
  },
}
